import React from 'react';

const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_16891_38130)" fill-opacity="0.1" />
      <path
        d="M7 12H17"
        stroke="url(#paint1_linear_16891_38130)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16891_38130"
          x1="5.625"
          y1="1.5"
          x2="19.6579"
          y2="23.9011"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.114583" stop-color="#FF5353" />
          <stop offset="0.623798" stop-color="#6D38FB" />
          <stop offset="1" stop-color="#009DFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16891_38130"
          x1="6.16667"
          y1="7"
          x2="17.3408"
          y2="15.9854"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.114583" stop-color="#FF5353" />
          <stop offset="0.623798" stop-color="#6D38FB" />
          <stop offset="1" stop-color="#009DFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CloseIcon;
